// frontend/src/components/Home.js
import React from 'react';
import Header from './Header';
import Cover from './Cover';
import About from './About';
import Carousel from './Carousel';
import FeaturesSection from './FeaturesSection';
import ServicesSection from './ServicesSection';
import Contacts from './Contacts';
import Map from './Map';

function Home() {
    return (
        <div>
            <Header />
            <Cover />
            <About />
            <Carousel />
            <FeaturesSection />
            <ServicesSection />
            <Contacts />
            <Map />
        </div>
    );
}

export default Home;